var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import { CircularProgress, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { useClients } from "../selectors";
export var ClientsAutocomplete = function (_a) {
    var _b;
    var clientId = _a.value, label = _a.label, onChange = _a.onChange;
    var _c = __read(React.useState(false), 2), isOpen = _c[0], setOpen = _c[1];
    var _d = useClients({}), data = _d.data, isLoading = _d.isLoading;
    var value = (_b = data === null || data === void 0 ? void 0 : data.items.find(function (client) { return client.id === clientId; })) !== null && _b !== void 0 ? _b : null;
    return (React.createElement(Autocomplete, { open: isOpen, onOpen: function () { return setOpen(true); }, onClose: function () { return setOpen(false); }, getOptionSelected: function (option, value) { return option.id === value.id; }, getOptionLabel: function (option) { var _a, _b, _c, _d; return (_d = (_b = (_a = option.user) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_c = option.user) === null || _c === void 0 ? void 0 : _c.email) !== null && _d !== void 0 ? _d : ""; }, options: data ? data.items : [], loading: isLoading, noOptionsText: "Не найдено ни одного клиента", loadingText: "Поиск...", value: value, fullWidth: true, onChange: function (_, user) {
            onChange(user);
        }, renderInput: function (params) { return (React.createElement(TextField, __assign({}, params, { label: label, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (React.createElement(React.Fragment, null,
                    isLoading && React.createElement(CircularProgress, { color: "inherit", size: 20 }),
                    params.InputProps.endAdornment)) }) }))); } }));
};
